import { Injectable } from '@angular/core';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { Solution } from './solution';
import { FileUpload } from '../attachment/fileUpload';

@Injectable({
  providedIn: 'root',
})
export class LeadsService {
  options = { authenticate: true, setRoot: true, updateAuthHeader: false };

  constructor(private api: GatewayAPIService) {}

  getSolution(solutionId: string): Promise<Solution> {
    return this.api
      .apiCallSane(
        '/solution',
        'GET',
        this.api.getMultipartHeaders(),
        {
          id: solutionId,
        },
        null,
        this.options,
      )
      .then((response: Partial<Solution>) => new Solution(response));
  }

  uploadAttachments(leadId: string, attachments: FileUpload[]): Promise<void> {
    let formData = new FormData();
    let metaData: { type: string | undefined; otherType: string | undefined }[] = [];

    for (var i = 0; i < attachments.length; i++) {
      formData.append('files', attachments[i].file);

      metaData.push({
        type: attachments[i].type,
        otherType: attachments[i].otherType,
      });
    }

    formData.append('leadId', leadId);
    formData.append('metadata', JSON.stringify(metaData));

    return this.api.apiCallSane(
      '/attachments',
      'POST',
      this.api.getMultipartHeaders(),
      null,
      formData,
      this.options,
    );
  }
}
